import { useTeamsQuery } from '@data/teams/useTeamsQuery';
import { TeamListFormData } from './contracts';
import TeamListUI from './TeamListUI';
import { SkeletonLoader } from '@ui/common/components/SkeletonLoader';

export type TeamListProps = TeamListFormData;

export function TeamList({ columns = 3, nameType }: TeamListProps) {
  const { data: teams, isLoading: areTeamsLoading, error: teamsError } = useTeamsQuery();

  if (areTeamsLoading) {
    return (
      <div style={{ display: 'block', width: '100%', height: '100%' }}>
        <SkeletonLoader count={21} />
      </div>
    );
  }

  if (!teams || teamsError) {
    return null;
  }

  return <TeamListUI teams={teams} columns={columns} nameType={nameType} />;
}
